import React, { Component } from 'react';
import { Collapse, Button, Icon } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';

import SmoothLinkTarget from 'components/SmoothLink/Target';
import { updateRequestProperties, updateRequestGeojson } from 'modules/userrequest';

import FormActivity from './FormActivity';

const { Panel } = Collapse;

const customPanelStyle = {
  background: '#f7f7f7',
  borderRadius: 4,
  marginBottom: 12,
  border: 0,
  overflow: 'hidden',
};

class FormActivities extends Component {
  state = {
    activityTypes: [],
  }

  componentDidMount () {
    const { activityTypes } = this.props;
    this.setState({ activityTypes });
  }

  addActivity = () => {
    const { activities } = this.props;
    const lastItem = activities.reduce(
      (acc, activity) => (activity.uid > acc.uid ? activity : acc),
      { uid: -Infinity },
    );
    const { uid, eventDates } = lastItem;

    this.props.updateRequestProperties({
      activities: [
        ...activities,
        {
          type: '',
          eventDates,
          uid: uid + 1,
        },
      ],
    });
  }

  deleteActivity = uid => {
    this.props.removeModelField('userrequest.properties.activities', uid);

    this.props.updateRequestProperties({
      activities: this.props.activities.filter(activity => activity.uid !== uid),
    });

    this.props.updateRequestGeojson({
      geojson: this.props.geojsonFeatures.filter(feature => feature.properties.activity !== uid),
    });
  }

  render () {
    const { activityTypes } = this.state;
    const { activities } = this.props;
    return (
      <React.Fragment>
        <Collapse defaultActiveKey={['0']} bordered={false} style={{ marginBottom: 24 }}>
          {activities.map((activity, i) => (
            <Panel
              forceRender
              header={(
                <div style={{ display: 'flex', marginRight: 12 }}>
                  <span style={{ flex: 1 }}>{`Activité ${i + 1}`}</span>
                  {activities.length > 1 && (
                    <Button
                      size="small"
                      type="danger"
                      style={{ textAlign: 'right' }}
                      onClick={() => this.deleteActivity(activity.uid)}
                    >
                      <Icon type="delete" /> Supprimer cette activité
                    </Button>
                  )}
                </div>
              )}
              style={customPanelStyle}
              key={activity.uid}
            >
              <SmoothLinkTarget
                name={`userrequest.properties.activities.${i}`}
              >
                <FormActivity
                  activityTypes={activityTypes}
                  activity={activity}
                  {...this.props}
                />
              </SmoothLinkTarget>
            </Panel>
          ))}
        </Collapse>

        <div style={{ marginBottom: 24, textAlign: 'right' }}>
          <Button type="primary" onClick={this.addActivity}>
            <Icon type="plus" /> Ajouter une activité
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  activities: state.userrequest.properties.activities,
  activityTypes: state.admin.activities.list,
  geojsonFeatures: state.userrequest.geojson.features,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    updateRequestProperties,
    updateRequestGeojson,
    removeModelField: actions.remove,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FormActivities);



// WEBPACK FOOTER //
// ./src/components/Form/FormActivities.js